<template>
  <div class="order-fliggy">
    <fliggy-order-info-bar :ota-info="otaInfo"></fliggy-order-info-bar>
    <div class="info-tips">
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-tips-orange.png" alt="">
      飞猪订单自动导入卖家填写的收货地址和买家留言，请确认后提交
    </div>
  </div>
</template>

<script>
import FliggyOrderInfoBar from '@/components/ota/fliggy-order-info-bar.vue';

export default {
  name: 'order-fliggy',
  components: {
    FliggyOrderInfoBar,
  },
  props: {
    otaInfo: Object,
  },
  data() {
    return {
    };
  },
};
</script>



<style lang="less" scoped>
@import '../../../assets/less/variable.less';
.order-fliggy{
  padding: 16px 24px;
  line-height: 1;
  background: #fff;
  border-radius:16px 16px 0px 0px;
  position: relative;
  z-index: 1;
  &::after{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 94px;
    background: url(https://o.666visa.cn/static/ssqpeer/order/fliggy-bg.png) no-repeat center / 100% 100%;
  }
  .order-fliggy-info{
    display: flex;
    align-items: center;
    .fliggy-icon{
      flex-shrink: 0;
      width: 22px;
      margin-right: 8px;
    }
    .info-name{
      color: #2F333D;
      font-size: 16px;
      color: #2F333D;
      margin-right: 5px;
    }
    .info-id{
      a{
        color:  #91999F;
        font-size: 14px;
        &:hover{
          color: #599FFF;
        }
      }
    }
  }
  .info-tips{
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    color: #FF8033;
    font-size: 14px;
    background: #FFF6DD;
    margin-top: 10px;
    border-radius:2px;
    .icon{
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-fliggy.vue